import { render, staticRenderFns } from "./ucFoot.vue?vue&type=template&id=53d3a6f4&"
import script from "./ucFoot.vue?vue&type=script&lang=js&"
export * from "./ucFoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports